import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
// import * as XLSX from 'xlsx';

import {
    BarChart,
    Bar,
    XAxis,
    YAxis,
    Tooltip,
    ResponsiveContainer,
    Cell
} from "recharts";


// import { SocketContext } from '../../context/SocketContext'
import { getUsuarioStorage } from '../../helpers/getUsuarioStorage'
import { useHideMenu } from '../../hooks/useHideMenu'
// import { UseCurrencyFormat } from '../../hooks/useCurrencyFormat';
import { useGetPantallas } from '../../hooks/useGetPantallas';

import { SelectElement } from "../../components/selectElement2";
// import { InformeTicketHoy } from '../../components/informeTicketHoy';
import { NoAcceso } from '../../components/NoAcceso';
import LoadingOverlay from '../../components/LoadingOverlay';
import { serverApi } from '../../api';

const colores = [
    "#3B82F6", // azul
    "#10B981", // verde
    "#F59E0B", // amarillo
    "#EF4444", // rojo
    "#8B5CF6", // morado
    "#EC4899", // rosa
    "#06B6D4", // cyan
    "#F97316"  // naranja
];

const formatDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Month is 0-based
    const day = String(date.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
}


// let usuario = getUsuarioStorage();
// const entidad = usuario.entidad;

const hoy = formatDate(new Date());

const initialForm = {
    search: '',
    page: 1,
    limit: 100,
    sortBy: 'hora',
    sortDir: 'asc',

    codigoEntidad: '',
    codigoUbicacion: '',

    fechaInicio: hoy,
    fechaFinal: hoy,

    uidModulo: '',
    uidTipoAtencion: '',
    uidAgente: '',
    filtroTiempo: 'dia'
}

export const Informes = () => {

    let [usuario] = useState(getUsuarioStorage())
    // const entidad = usuario.entidad;
    const pantallas = useGetPantallas();

    const [query, setQuery] = useState(initialForm);

    const navigate = useNavigate();
    useEffect(() => {
        if (usuario.uidUsuario === null) {
            // return <Navigate to="/ingreso" />
            navigate("/Ingreso")
        }
    }, [usuario.uidUsuario, navigate])

    useEffect(() => {
        setQuery(prev => ({
            ...prev,
            codigoEntidad: usuario.codigoEntidad,
            codigoUbicacion: usuario.codigoUbicacion
        }));
    }, [usuario])



    useHideMenu(false);

    // const formatoNumero = (numero) => {

    //     return UseCurrencyFormat(numero);
    // }




    // const { socket } = useContext( SocketContext );

    const [isLoading, setIsLoading] = useState(false);
    const [atencion, setAtencion] = useState([]);
    // const [ atencionTipo, setAtencionTipo ] = useState([]);
    const [modulo, setModulo] = useState([]);
    const [agente, setAgente] = useState([]);

    const [dashboard, setDashboard] = useState({
        resumen: {},
        tipos: [],
        modulos: [],
        agentes: [],
        medicos: []
    });

    // const [ atencionPromedioAtencion, setAtencionPromedioAtencion ] = useState(0);
    // const [ atencionPromedioModulo, setAtencionPromedioModulo ] = useState(0);
    // const [ atencionPromedioAgente, setAtencionPromedioAgente ] = useState(0);




    // const [ fechaInicio, setFechaInicio ] = useState('');
    // const [ fechaFinal, setFechaFinal ] = useState('');
    // const [ filtroTiempo, setFiltroTiempo ] = useState('dia');

    // const [ moduloSeleccionado, setModuloSeleccionado ] = useState('');
    // const [ atencionSeleccionado, setAtencionSeleccionado ] = useState('');
    // const [ agenteSeleccionado, setAgenteSeleccionado ] = useState('');

    useEffect(() => {

        try {
            const fetch = async () => {

                const resp = await serverApi.post(`/tipos-atencion/select-tiposatencion`, { ...query });
                const opciones = resp.data.lista.map((item) => ({ value: item.uidTipoAtencion, label: ` ${item.tipoAtencion.toUpperCase()}` }))
                setAtencion(opciones)

            };
            fetch();
        } catch (error) {
            console.error("Error al obtener clases Tipos de Atención", error);
        } finally {

        }

    }, [query])


    useEffect(() => {

        try {
            const fetch = async () => {

                const resp = await serverApi.post(`/modulos/select-modulos`, { ...query });
                const opciones = resp.data.listaModulos.map((item) => ({ value: item.uidModulo, label: ` ${item.moduloClase.toUpperCase()} - ${item.modulo.toUpperCase()} ` }))
                setModulo(opciones)
            }

            fetch();

        } catch (error) {
            console.error("Error al obtener clases Modulos", error);
        } finally {

        }


    }, [query])

    useEffect(() => {

        try {
            const fetch = async () => {

                const resp = await serverApi.post(`/usuarios/select-usuarios`, { ...query });
                const opciones = resp.data.data.map((item) => ({ value: item.uidUsuario, label: item.nombreCompleto.toUpperCase() }))
                setAgente(opciones);
            };

            fetch();
        } catch (error) {
            console.error("Error al obtener los usuarios", error);
        } finally {

        }

    }, [query])



    useEffect(() => {

        const cargarDashboard = async () => {

            try {

                setIsLoading(true);
                const resp = await serverApi.post('/informes/dashboard', query);
                console.log(resp.data);

                setDashboard(resp.data);

            }
            catch (error) {
                console.log(error);
            }
            finally {
                setIsLoading(false);
            }

        }

        cargarDashboard();

    }, [query]);






    const handleSelectTipoAtencion = (selected) => {
        setQuery(prev => ({
            ...prev,
            uidTipoAtencion: selected.value,

        }));
    };

    const handleSelectModulo = (selected) => {
        setQuery(prev => ({
            ...prev,
            uidModulo: selected.value,

        }));
    };

    const handleSelectAgente = (selected) => {
        setQuery(prev => ({
            ...prev,
            uidAgente: selected.value,

        }));
    };

    const handleFechaInicio = (e) => {

        const fecha = e.target.value;

        setQuery(prev => ({

            ...prev,

            fechaInicio: fecha,

            fechaFinal:
                prev.fechaFinal < fecha
                    ? fecha
                    : prev.fechaFinal
        }));

    };

    const handleFechaFinal = (e) => {

        setQuery(prev => ({

            ...prev,

            fechaFinal: e.target.value

        }));

    };

    // const exportToExcel = (tabla, name) => {


    //     const table = document.getElementById(`${tabla}`);
    //     const wb = XLSX.utils.table_to_book(table, {
    //         dateNF: 'YYYY-MM-DD',
    //     });

    //     for (const col in wb) {
    //         if (wb.hasOwnProperty(col) && col[0] !== '!') {
    //             const cell = wb[col];
    //             if (cell.t === 'd') {
    //                 cell.z = 'yyyy-mm-dd';
    //             }
    //         }
    //     }

    //     /* Export to file (start a download) */
    //     XLSX.writeFile(wb, `${name}.xlsx`);

    // };

    // const exportToExcelFromData = (data, name) => {

    //     console.log(data);
    //     const ws = XLSX.utils.json_to_sheet(data, {
    //         dateNF: 'yyyy-mm-dd' // Set the date format
    //     });

    //     const wb = XLSX.utils.book_new();
    //     XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    //     XLSX.writeFile(wb, `${name}.xlsx`);

    // };


    if (usuario.uidUsuario === null) {
        return (
            <>
            </>
        )
    }
    else if (!pantallas.includes("informes")) {
        return (<NoAcceso />)
    }
    else {

        { isLoading && <LoadingOverlay /> }
        return (
            <div className={` ${isLoading ? 'opacity' : ''} m-5`}
                style={{ minHeight: '100vh' }} >
                <div className='row p-3'>

                    {/* <InformeTicketHoy /> */}

                    <div className="card rounded shadow p-3 mt-3 mb-3">
                        <h5 className='card-title'> <b>FILTROS</b> </h5>
                        <div className='row'>
                            <div className='row'>

                                <div className='col-4'>
                                    <input type="radio"
                                        className="btn-check"
                                        name="opcionTiempo"
                                        id="opcionAnio"
                                        autoComplete="off"
                                        // onClick={() => setFiltroTiempo('anio')} 
                                        onClick={() => {
                                            console.log('anio');

                                        }}
                                    />
                                    <label className="btn btn-outline-primary" htmlFor="opcionAnio">Año</label>

                                    {' '}
                                    <input type="radio"
                                        className="btn-check"
                                        name="opcionTiempo"
                                        id="opcionMes"
                                        autoComplete="off"
                                        // onClick={() => setFiltroTiempo('anio')} 
                                        onClick={() => {
                                            console.log('anio');

                                        }}
                                    />
                                    <label className="btn btn-outline-primary" htmlFor="opcionMes">Mes</label>

                                    {' '}
                                    <input type="radio"
                                        className="btn-check"
                                        name="opcionTiempo"
                                        id="opcionDia"
                                        autoComplete="off"
                                        // onClick={() => setFiltroTiempo('anio')} 
                                        onClick={() => {
                                            console.log('anio');

                                        }}
                                    />
                                    <label className="btn btn-outline-primary" htmlFor="opcionDia">Día</label>

                                </div>

                            </div>


                            <div className='form-group col-lg-3 col-12 mt-3' >
                                <div className='label'>Inicio </div>
                                <input
                                    type="date"
                                    className='form-control'
                                    name="fechaInicio"
                                    id="fechaInicio"
                                    // defaultValue= { formatDate(new Date()) }
                                    value={query.fechaInicio}
                                    onChange={handleFechaInicio}
                                    placeholder="Inicio" />
                            </div>

                            <div className="form-group col-lg-3 col-12 mt-3">
                                <div className='label' > Final </div>
                                <input
                                    type="date"
                                    className='form-control'
                                    name="fechaFinal"
                                    id="fechaFinal"
                                    // defaultValue= { formatDate(new Date()) }
                                    min={query.fechaInicio}
                                    value={query.fechaFinal}
                                    onChange={handleFechaFinal}
                                    placeholder="Final"
                                />

                            </div>

                            <div className='form-group col-lg-3 col-12 mt-3'>

                                <div className='label'>Tipos Atención</div>
                                <SelectElement
                                    options={atencion}
                                    name={"uidTipoAtencion"}
                                    isMulti={false}
                                    closeOnMenuSelect={true}
                                    // onChange= {(ev) => setAtencionSeleccionado( ev === null ? '' : ev.value ) }
                                    value={atencion.find(u => u.value === query.uidTipoAtencion)}
                                    onChange={(selected) => handleSelectTipoAtencion(selected)}
                                    classname="form-control form-control-lg"
                                    isClearable={true}
                                />
                            </div>

                            <div className='form-group col-lg-3 col-12 mt-3'>

                                <div className='label'>Módulos</div>
                                <SelectElement
                                    options={modulo}
                                    name={"uidModulo"}
                                    isMulti={false}
                                    closeOnMenuSelect={true}
                                    // onChange= {(ev) => setModuloSeleccionado( ev === null ? '' : ev.value ) }
                                    value={modulo.find(u => u.value === query.uidModulo)}
                                    onChange={(selected) => handleSelectModulo(selected)}
                                    classname="form-control form-control-lg"
                                    isClearable={true}
                                />
                            </div>

                            <div className='form-group col-lg-3 col-12 mt-3'>

                                <div className='label'>Agentes</div>
                                <SelectElement
                                    options={agente}
                                    name={"uidUsuario"}
                                    isMulti={false}
                                    closeOnMenuSelect={true}
                                    // onChange= {(ev) => setAgenteSeleccionado( ev === null ? '' : ev.value ) }
                                    value={agente.find(u => u.value === query.uidUsuario)}
                                    onChange={(selected) => handleSelectAgente(selected)}
                                    classname="form-control form-control-lg"
                                    isClearable={true}
                                />
                            </div>

                        </div>


                    </div>

                    <div className='row mb-4'>

                        <div className='col-md-3'>
                            <div className='card shadow'>
                                <div className='card-body'>
                                    <h6>Total pacientes</h6>
                                    <h1>{dashboard.resumen.totalPacientes || 0}</h1>

                                </div>
                            </div>
                        </div>

                        <div className='col-md-3'>
                            <div className='card shadow'>
                                <div className='card-body'>
                                    <h6>Total flujos</h6>
                                    <h1>{dashboard.resumen.totalFlujos || 0}</h1>
                                </div>
                            </div>
                        </div>

                        <div className='col-md-3'>
                            <div className='card shadow'>
                                <div className='card-body'>
                                    <h6>Promedio llamado</h6>
                                    <h4>{dashboard.resumen.promedioLlamado}</h4>
                                </div>
                            </div>
                        </div>

                        <div className='col-md-3'>
                            <div className='card shadow'>
                                <div className='card-body'>
                                    <h6>Promedio atención</h6>
                                    <h4>{dashboard.resumen.promedioAtencion}</h4>
                                </div>
                            </div>
                        </div>

                    </div>

                    {/*  Grafico */}
                    <div className='card shadow mt-4 border-0'>

                        <div className='card-header bg-white'>

                            <h5 className='m-0'>
                                Atenciones por médico
                            </h5>

                        </div>

                        <div className='card-body'>

                            <ResponsiveContainer
                                width="100%"
                                height={350}
                            >

                                <BarChart
                                    data={dashboard.medicos}
                                >

                                    <XAxis
                                        dataKey="nombreCompleto"
                                        tick={{
                                            fontSize: 12
                                        }}
                                    />

                                    <YAxis />

                                    <Tooltip />

                                    <Bar
                                        dataKey="pacientesAtendidos"
                                        radius={[10, 10, 0, 0]}
                                    >

                                        {

                                            dashboard.medicos.map(
                                                (entry, index) => (

                                                    <Cell
                                                        key={index}
                                                        fill={
                                                            colores[
                                                            index %
                                                            colores.length
                                                            ]
                                                        }
                                                    />

                                                ))

                                        }

                                    </Bar>

                                </BarChart>

                            </ResponsiveContainer>

                        </div>

                    </div>

                    <div className="card shadow mt-4">

                        <div className="card-header bg-white d-flex justify-content-between align-items-center">

                            <h5 className="m-0">
                                Atenciones por médico
                            </h5>

                            <span className="badge bg-primary fs-6">
                                {dashboard.medicos.length} médicos
                            </span>

                        </div>

                        <div className="card-body p-0">

                            <div className="list-group list-group-flush">

                                {

                                    dashboard.medicos.map(
                                        (item, index) => {

                                            const porcentaje =
                                                (
                                                    (
                                                        item.pacientesAtendidos /
                                                        dashboard.medicos[0]
                                                            ?.pacientesAtendidos
                                                    ) * 100
                                                ).toFixed(0);

                                            return (

                                                <div
                                                    key={index}
                                                    className="
                        list-group-item
                        py-3 px-4
                        border-0
                        border-bottom
                        "
                                                >

                                                    <div className="
                            d-flex
                            justify-content-between
                            align-items-center
                            mb-2
                        ">

                                                        <div>

                                                            <h6
                                                                className="
                                mb-1
                                fw-bold
                                "
                                                            >

                                                                {item.nombreCompleto}

                                                            </h6>

                                                            <small
                                                                className="
                                text-muted
                                "
                                                            >

                                                                Tiempo promedio:
                                                                {" "}
                                                                {item.promedioAtencion}

                                                            </small>

                                                        </div>

                                                        <div
                                                            className="
                            text-end
                            "
                                                        >

                                                            <span
                                                                className="
                                badge
                                bg-success
                                fs-6
                                "
                                                            >

                                                                {
                                                                    item.pacientesAtendidos
                                                                }

                                                            </span>

                                                            <div>

                                                                <small
                                                                    className="
                                text-muted
                                "
                                                                >

                                                                    pacientes

                                                                </small>

                                                            </div>

                                                        </div>

                                                    </div>


                                                    <div
                                                        className="
                        progress
                        "
                                                        style={{
                                                            height: "8px"
                                                        }}
                                                    >

                                                        <div

                                                            className="
                            progress-bar
                            progress-bar-striped
                            progress-bar-animated
                            "

                                                            style={{

                                                                width:
                                                                    `${porcentaje}%`

                                                            }}

                                                        />

                                                    </div>


                                                </div>

                                            )

                                        })

                                }

                            </div>

                        </div>

                    </div>



                </div>

            </div>

        )
    }

}
